import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import addVisibilityObserver from '@/js/components/useVisibilityObserver';
import BaseComponent from './baseComponent';

gsap.registerPlugin(ScrollTrigger);

export default class CtaIllustrated extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.el = document.querySelector('[data-cta-illustrated]');
    this.debug = false;

    if (this.el) {
      this.ctaText = this.el.querySelector('.content > .cta-text');
      this.ctaButton = this.el.querySelector('.content > .cta-button');
      this.illustration = this.el.querySelector('.illustration');
    }
  }

  init() {
    if (!this.el) {
      return;
    }

    addVisibilityObserver(this.el, {
      onFirstEnter: () => {
        console.log('CtaIllustrated initialised');
        this.animation();
      },
    }, {
      // rootMargin: '-500px',
      threshold: 0,
    });
  }

  animation() {
    // create match media queries
    const mm = gsap.matchMedia();

    // following scroll-animation only runs on viewport large
    mm.add('(min-width: 992px)', () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          markers: this.debug,
          start: 'top 50%',
          end: 'top 10%',
          scrub: 0.5, // true or seconds
        },
      });

      tl.from(
        this.ctaText,
        { transform: 'scale(1.6)', duration: 0.8 },
      ).fromTo(this.ctaButton, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7 }, '<+=0.5')
        .fromTo(this.illustration, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.7 }, '<');
    });
  }
}
